// Module
var code = `<ex-mono-occurrence-ecran mono-occurrence-options="vm.monoOccurrenceOptions" largeur-formulaire="65"> </ex-mono-occurrence-ecran> `;
// Exports
module.exports = code;